
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M17.875 11.459a2.293 2.293 0 012.291-2.292V8.25c0-3.666-.916-4.583-4.583-4.583H6.416c-3.666 0-4.583.917-4.583 4.583v.458A2.293 2.293 0 014.125 11a2.293 2.293 0 01-2.292 2.292v.458c0 3.667.917 4.583 4.583 4.583h9.167c3.667 0 4.583-.917 4.583-4.583a2.293 2.293 0 01-2.291-2.291z","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.25 13.521l5.5-5.5","stroke-width":"1.5","opacity":".4"}}),_c('path',{attrs:{"d":"M13.745 13.521h.005M8.245 8.479h.005","stroke-width":"2","opacity":".4"}})])])
          )
        }
      }
    